/**
 * Splits a list into consecutive groups of the given size,
 * the last group holding the remainder.
 */
export const chunk = <T>(list: T[], size: number): T[][] => {
  return list.reduce<T[][]>((acc, el, i) => {
    if (i % size === 0) {
      acc.push([])
    }

    acc[acc.length - 1].push(el)

    return acc
  }, [])
}

export const startsWith = <T>(list1: T[], list2: T[]): boolean => {
  return list2.every((el, i) => {
    return list1[i] === el
  })
}

/**
 * The function allows to write a composition of filter and map
 * in such a way that the code remains easy to read,
 * but is executed in an optimal way using reduce
 */
export const filterMap = <T, U>(
  list: T[],
  filterCb: (el: T) => boolean,
  mapCb: (el: T) => U
): U[] => {
  return list.reduce<U[]>((acc, el) => {
    if (filterCb(el)) {
      acc.push(mapCb(el))
    }
    return acc
  }, [])
}
